<div class="card card--department h-100 p-2 p-sm-4 text-center align-items-center cursor-pointer overflow-hidden"
  (click)="navigateToDeptInfo()"
  [title]="serviceName"
>
  <div class="department-logo">
    <img
      imgFallback
      loading="lazy"
      fetchpriority="high"
      
      width="100"
      height="100"
      [src]="srvLogoUrl"
      [alt]="serviceName"
    />
  </div>
  <h4 class="department-name line-clamp-3 pt-1">
    {{ serviceName || "N.A." }}
  </h4>
  <span class="category" [title]="category">{{ category || "N.A." }}</span>
</div>
